import React, { useState } from 'react'
import './AddPumpModal.scss'
import { ModalWrapper } from 'Components'

interface StationLocationModalProps {
  isOpen: boolean
  onClose: () => void
  station: any
}

const StationLocationModal: React.FC<StationLocationModalProps> = ({ isOpen, onClose, station }) => {
  const [showLargeMap, setShowLargeMap] = useState(false)

  const handleViewLargeMap = () => {
    setShowLargeMap(true)
  }

  const handleCloseLargeMap = () => {
    setShowLargeMap(false)
  }

  if (!isOpen) return null

  const mapSrc = station?.latitude && station?.longitude 
    ? `https://www.google.com/maps?q=${station.latitude},${station.longitude}&z=15&output=embed`
    : ''

  return (
    <>
      <ModalWrapper showModal={isOpen} size={'lg'} closeModal={onClose} title="Station Location" hideHeader={false}>
        <div className='station-location-modal'>
          {station?.latitude && station?.longitude ? (
            <div style={{ position: 'relative' }} className='mt-3'>
              <iframe
                id='station-map'
                src={mapSrc}
                width='100%'
                height='300'
                style={{ border: 0 }}
                allowFullScreen={true}
                allow='fullscreen'
                loading='lazy'
                referrerPolicy='no-referrer-when-downgrade'
                className='p-0'
                title='station-location-map'
              />
              <button
                type='button'
                onClick={handleViewLargeMap}
                style={{
                  position: 'absolute',
                  right: '16px',
                  bottom: '16px',
                  zIndex: 2,
                  background: '#fff',
                  border: '1px solid #ddd',
                  padding: '6px 10px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '.8rem',
                }}
                className='btn btn-sm'
              >
                View large map
              </button>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p className='text-muted'>Location coordinates not available</p>
            </div>
          )}
        </div>
      </ModalWrapper>

      {showLargeMap && (
        <div 
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '2147483647',
          }}
          onClick={handleCloseLargeMap}
        >
          <div 
            style={{
              width: '95%',
              height: '90%',
              maxWidth: '1200px',
              maxHeight: '900px',
              background: '#fff',
              borderRadius: '8px',
              overflow: 'hidden',
              position: 'relative',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseLargeMap}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: '10',
                background: '#fff',
                border: '1px solid #ddd',
                padding: '6px 10px',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Close
            </button>
            <iframe
              src={mapSrc}
              style={{
                width: '100%',
                height: '100%',
                border: '0',
              }}
              allowFullScreen={true}
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
              title='station-large-map'
            />
          </div>
        </div>
      )}
    </>
  )
}

export default StationLocationModal
